import React from 'react';

interface NumberFormatProps {
    value: any;
    locale?: string;
    options?: Intl.NumberFormatOptions;
    space?: any
}
const NumberFormat: React.FC<NumberFormatProps> = ({value, locale = 'en-US', options = {}, space}) => {
    const formatter = new Intl.NumberFormat(locale, options);
    return <>{formatter.format(value)}{space && ' '}</>;
};

export default NumberFormat;